import axios from "axios";

/**
 * Loads every page of a paginated list endpoint ({pagination, results}).
 * @param {string} url
 * @param {AbortSignal} [signal]
 */
export const fetchAll = async (url, signal) => {
    const results = [];
    let page = 1;
    while (page) {
        const {data} = await axios.get(url, {params: {page, page_size: 100}, signal});
        results.push(...data.results);
        page = data.pagination.next_page;
    }
    return results;
};
